/**
 * @generated SignedSource<<7d3622ef0dd0d7250fb438491e829e1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type topicsQuery$variables = {
  categories?: ReadonlyArray<string> | null | undefined;
  organizations?: ReadonlyArray<string> | null | undefined;
  q?: string | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
  topics?: ReadonlyArray<string> | null | undefined;
};
export type topicsQuery$data = {
  readonly topics: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayName: string;
        readonly name: string;
      };
    }>;
  };
};
export type topicsQuery = {
  response: topicsQuery$data;
  variables: topicsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categories"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizations"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "q"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tags"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topics"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "categories",
            "variableName": "categories"
          },
          {
            "kind": "Variable",
            "name": "organizations",
            "variableName": "organizations"
          },
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "q"
          },
          {
            "kind": "Variable",
            "name": "tags",
            "variableName": "tags"
          },
          {
            "kind": "Variable",
            "name": "topics",
            "variableName": "topics"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      }
    ],
    "concreteType": "TopicConnection",
    "kind": "LinkedField",
    "name": "topics",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TopicEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "topicsQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "topicsQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "492371bd59eb6abb9a4aa40988899eb9",
    "id": null,
    "metadata": {},
    "name": "topicsQuery",
    "operationKind": "query",
    "text": "query topicsQuery(\n  $q: String\n  $tags: [String!]\n  $categories: [String!]\n  $organizations: [String!]\n  $topics: [String!]\n) {\n  topics(filter: {q: $q, topics: $topics, tags: $tags, organizations: $organizations, categories: $categories}) {\n    edges {\n      node {\n        name\n        displayName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "13aef91964eb042dfa0b614a5ff58619";

export default node;
